module.exports = __webpack_public_path__ + "static/volcan-d25ded0abbee31b3cfcdc3afb738da54.mp4";